import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from "@angular/core";
import { AGROUTES, DISROUTES ,SUROUTES} from './vertical-menu-routes.config';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations,
  styles: [`
    /* Modern Profile Styles - Light Purple Theme */
    .user-profile-container.modern-profile {
      position: relative;
      margin: 1rem 0.75rem 1.25rem;
      padding: 0;
      border-radius: 18px;
      overflow: hidden;
      background: linear-gradient(135deg, #9D50BB 0%, #6E48AA 100%);
      box-shadow: 0 8px 20px rgba(157, 80, 187, 0.3);
      transition: all 0.3s ease;
    }

    .user-profile-container.modern-profile:hover {
      box-shadow: 0 12px 28px rgba(157, 80, 187, 0.4);
      transform: translateY(-2px);
    }

    .profile-gradient-bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.03) 100%);
      z-index: 1;
    }

    .profile-gradient-bg::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -20%;
      width: 130px;
      height: 130px;
      background: radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 70%);
      border-radius: 50%;
    }

    .profile-content {
      position: relative;
      z-index: 2;

      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .profile-image-wrapper {
      position: relative;
      display: inline-block;
      margin-bottom: 0.75rem;
    }

    .profile-image-ring {
      width: 75px;
      height: 75px;
      padding: 3px;
      background: linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.9) 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 16px rgba(0,0,0,0.2);
      position: relative;
    }

    .profile-image-ring::before {
      content: '';
      position: absolute;
      inset: -3px;
      background: linear-gradient(135deg, #B39DDB 0%, #CE93D8 100%);
      border-radius: 50%;
      z-index: -1;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .profile-image-wrapper:hover .profile-image-ring::before {
      opacity: 1;
    }

    .profile-img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      object-fit: cover;
      border: 3px solid #fff;
    }

    .profile-status-badge {
      position: absolute;
      bottom: 2px;
      right: 2px;
      width: 14px;
      height: 14px;
      background: linear-gradient(135deg, #40C057 0%, #2ecc71 100%);
      border: 2.5px solid #fff;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(64, 192, 87, 0.5);
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.1); box-shadow: 0 0 0 3px rgba(64, 192, 87, 0.3); }
    }

    .profile-details {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .user-name {
      font-size: 1.05rem;
      font-weight: 700;
      color: #fff;
      margin-bottom: 0.4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.35rem;
      line-height: 1.3;
      text-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .verified-badge {
      display: inline-flex;
      color: #81D4FA;
      font-size: 0.95rem;
      filter: drop-shadow(0 2px 4px rgba(129, 212, 250, 0.4));
    }

    .user-role {
      display: inline-block;
      font-size: 0.68rem;
      font-weight: 700;
      color: #fff;
      background: linear-gradient(135deg, rgba(255,255,255,0.28) 0%, rgba(255,255,255,0.15) 100%);
      padding: 0.3rem 0.85rem;
      border-radius: 14px;
      margin-bottom: 0.65rem;
      text-transform: uppercase;
      letter-spacing: 0.7px;
      border: 1px solid rgba(255,255,255,0.2);
      backdrop-filter: blur(10px);
    }

    .user-contact-info {
      margin-bottom: 0;
      padding: 0;
      width: 100%;
      max-width: 200px;
    }

    .user-info-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 0.45rem;
      font-size: 0.7rem;
      color: rgba(255,255,255,0.95);
      margin-bottom: 0.3rem;
      font-weight: 500;
      background: rgba(255,255,255,0.12);
      padding: 0.4rem 0.65rem;
      border-radius: 10px;
      backdrop-filter: blur(10px);
    }

    .user-info-item:last-child {
      margin-bottom: 0;
    }

    .user-info-item i {
      font-size: 0.75rem;
      opacity: 0.95;
      color: #B39DDB;
      flex-shrink: 0;
    }

    .user-info-item span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
      text-align: left;
    }

    /* Enhanced menu items - Light Purple Theme */
    .navigation > li:not(.user-profile-container) {
      margin-bottom: 0.25rem;
    }

    .navigation > li > a {
      padding: 0.85rem 1.25rem;
      border-radius: 10px;
      margin: 0 0.75rem;
      transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
    }

    .navigation > li > a::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 0;
      background: linear-gradient(135deg, #B39DDB 0%, #CE93D8 100%);
      border-radius: 0 4px 4px 0;
      transition: height 0.3s ease;
    }

    .navigation > li > a:hover {
      background: linear-gradient(90deg, rgba(179, 157, 219, 0.2) 0%, rgba(179, 157, 219, 0.08) 100%);
      transform: translateX(5px);
      padding-left: 1.5rem;
      color: #E1BEE7;
    }

    .navigation > li > a:hover::before {
      height: 70%;
    }

    .navigation > li.active > a,
    .navigation > li.open > a {
      background: linear-gradient(90deg, rgba(179, 157, 219, 0.25) 0%, rgba(179, 157, 219, 0.1) 100%);
      color: #F3E5F5;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(157, 80, 187, 0.15);
    }

    .navigation > li.active > a::before,
    .navigation > li.open > a::before {
      height: 80%;
    }

    /* Sidebar header improvements */
    .sidebar-header {
      padding: 0.5rem 1rem;
      border-bottom: 1px solid rgba(179, 157, 219, 0.15);
      background: linear-gradient(180deg, rgba(179, 157, 219, 0.05) 0%, transparent 100%);
    }

    .logo-img img {
      max-height: 40px;
      width: auto;
      filter: drop-shadow(0 2px 4px rgba(0,0,0,0.05));
    }

    /* Menu icons with gradient */
    .navigation i {
      width: 22px;
      text-align: center;
      margin-right: 0.75rem;
      font-size: 1.1rem;
      background: linear-gradient(135deg, #B39DDB 0%, #CE93D8 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    .navigation > li.active i,
    .navigation > li.open i {
      background: linear-gradient(135deg, #E1BEE7 0%, #CE93D8 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }

    /* Submenu styling */
    .menu-content {
      background: rgba(179, 157, 219, 0.08);
      border-radius: 8px;
      margin: 0.4rem 0.75rem;
      padding: 0.25rem 0;
    }

    .menu-content li a {
      padding: 0.65rem 1rem 0.65rem 2.75rem;
      font-size: 0.88rem;
    }

    /* Scrollbar styling */
    .sidebar-content::-webkit-scrollbar {
      width: 6px;
    }

    .sidebar-content::-webkit-scrollbar-track {
      background: rgba(179, 157, 219, 0.1);
    }

    .sidebar-content::-webkit-scrollbar-thumb {
      background: linear-gradient(180deg, #9D50BB 0%, #7B40A8 100%);
      border-radius: 10px;
    }

    .sidebar-content::-webkit-scrollbar-thumb:hover {
      background: linear-gradient(180deg, #B39DDB 0%, #9D50BB 100%);
    }
  `]
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  // logoUrl = 'assets/img/collector_light.svg';
  logoUrl = 'assets/img/collector_svg.svg';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  userData: any = null;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    const user = localStorage.getItem('admin');
    this.userData = user ? JSON.parse(user) : null;
    console.log(this.userData);
    this.isTouchDevice();
  }
  ngOnInit() {
    if (this.userData) {
      if (this.userData.roleName === 'Distributor') {
        this.menuItems = DISROUTES;
      } else if (this.userData.roleName === 'Agent') {
        this.menuItems = AGROUTES;
      } else if (this.userData.roleName === 'Super User') {
        this.menuItems = SUROUTES;
      }
    }
  }
  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {
    // if (this.config.layout.menuPosition === "Top") {
    //   if (this.innerWidth < 1200) {
    //     this.menuItems = ROUTES;
    //   }
    // }
    // else if (this.config.layout.menuPosition === "Side") {
    //   this.menuItems = ROUTES;
    // }
    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/collector_light.svg';
    }
    else {
      this.logoUrl = 'assets/img/collector_light.svg';
    }
    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }

  onImageError(event: any) {
    event.target.src = 'assets/img/portrait/small/avatar-s-1.png';
  }

}
